import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD8UJP0rkVRK1JG1Yz49Kda68SedSvG0Uc",
  authDomain: "convive-a5305.firebaseapp.com",
  projectId: "convive-a5305",
  storageBucket: "convive-a5305.firebasestorage.app",
  messagingSenderId: "309010190352",
  appId: "1:309010190352:web:a475a2f4fca7e43f913a95",
  measurementId: "G-05F8YNW6SR"
};

// Initialize Firebase with latest API
const app = initializeApp(firebaseConfig);

// Initialize Firebase services with latest APIs
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Firebase Cloud Messaging with latest API and proper error handling
export const messaging = (async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    } else {
      console.warn('Firebase Cloud Messaging not supported in this environment');
      return null;
    }
  } catch (error) {
    console.error('Error initializing Firebase Cloud Messaging:', error);
    return null;
  }
})();

// Export the app instance for potential future use
export default app; 